import { Injectable } from '@angular/core';
import { StorageService } from '@thinglogix/ngx-foundry-core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root',
})
export class CookieStorageService implements StorageService {
    constructor(private cookieService: CookieService) {}

    getAll(): Promise<any> {
        return Promise.resolve(this.cookieService.getAll());
    }

    check(key: string): Promise<boolean> {
        return Promise.resolve(this.cookieService.check(key));
    }

    remove(key: string): Promise<any> {
        return Promise.resolve(this.cookieService.delete(key));
    }

    set(
        key: string,
        value: string,
        opts: {
            expires: Date;
            path: string;
            domain: string;
            secure: boolean;
            sameSite: 'Lax' | 'None' | 'Strict';
        }
    ): Promise<any> {
        return Promise.resolve(
            this.cookieService.set(
                key,
                value,
                opts.expires,
                opts.path,
                opts.domain,
                opts.secure,
                opts.sameSite
            )
        );
    }

    get(key: string): Promise<any> {
        return Promise.resolve(this.cookieService.get(key));
    }

    clear(): Promise<void> {
        return new Promise<void>((resolve) => {
            Object.keys(this.cookieService.getAll()).forEach((key) => {
                if (key === 'browserId' || key === 'mfaExpireDays') {
                    return;
                }
                this.cookieService.delete(key, '/');
            });
            return resolve();
        });
    }
}
